import React, { useState } from 'react';
import { SeeMoreButton } from 'components/form-elements/buttons/SeeMoreButton';
import { BrikkModal } from 'components/modals/BrikkModal';
import { useUserDetails } from 'services/user/details/hook';
import { Brikk } from 'components/Brikk';
import { ServiceIcon } from 'assets/icons/brikks/ServiceIcon';
import { BrikkInfoModal } from 'components/modals/BrikkInfoModal';
import { InfoButton } from 'components/form-elements/buttons/InfoButton';
import { ServiceReportPreview } from 'components/brikks/home/ServiceReport/components/ServiceReportPreview';
import Draggable from 'components/drag-and-drop/Draggable';
import ServiceReportModal from 'components/brikks/home/ServiceReport/components/ServiceReportModal';

export const ServiceReport = ({ position, status, code, name }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);

  const { isLoading } = useUserDetails();

  const handleInfoModal = (e) => {
    e.stopPropagation();
    setIsInfoModalOpen(!isInfoModalOpen);
  };

  const handleOpenModal = (e) => {
    e.stopPropagation();
    setIsModalOpen(true);
  };

  return (
    <>
      <Draggable position={position}>
        <Brikk
          isLoading={isLoading}
          brikkKey={code}
          name={name}
          status={status}
        >
          <Brikk.Header
            icon={<ServiceIcon />}
            heading="serviceReportBrikk"
            brikkKey={code}
            status={status}
          />

          <Brikk.Content>
            <ServiceReportPreview />
          </Brikk.Content>

          <Brikk.Button>
            <SeeMoreButton
              onClick={handleOpenModal}
              brikkNameIntl="serviceReport"
            />
            <InfoButton
              showModal={isInfoModalOpen}
              onClick={handleInfoModal}
            />
          </Brikk.Button>
        </Brikk>
      </Draggable>

      <BrikkInfoModal
        title="Service report info"
        // info={info}
        showModal={isInfoModalOpen}
        onClick={() => setIsInfoModalOpen(!isInfoModalOpen)}
      />

      <BrikkModal
        isOpen={isModalOpen}
        heading="serviceReport"
        onClose={() => setIsModalOpen(false)}
      >
        <ServiceReportModal />
      </BrikkModal>
    </>
  );
};
